import React from 'react';

export default () => (
    <>
        <div
            style={{
                position: 'absolute',
                height: 2,
                width: '100%',
                top: 0,
                right: 0,
                zIndex: 1,
                background: 'repeating-linear-gradient(90deg,white,white 3px,#d9dadb 6px,#d9dadb 12px)',
                opacity: 0.75,
            }}
        />
        <div
            style={{
                position: 'absolute',
                height: '100%',
                width: 2,
                top: 0,
                right: 0,
                zIndex: 1,
                background: 'repeating-linear-gradient(0deg,white,white 3px,#d9dadb 6px,#d9dadb 12px)',
                opacity: 0.75,
            }}
        />
        <div
            style={{
                position: 'absolute',
                height: 2,
                width: '100%',
                bottom: 0,
                right: 0,
                zIndex: 1,
                background: 'repeating-linear-gradient(90deg,white,white 3px,#d9dadb 6px,#d9dadb 12px)',
                opacity: 0.75,
            }}
        />
        <div
            style={{
                position: 'absolute',
                height: '100%',
                width: 2,
                top: 0,
                left: 0,
                zIndex: 1,
                background: 'repeating-linear-gradient(0deg,white,white 3px,#d9dadb 6px,#d9dadb 12px)',
                opacity: 0.75,
            }}
        />
    </>
);
